module.exports = __webpack_public_path__ + "static/media/GCO.c9af97f6.png";